import { setNotification } from "features/Notification/notificationSlice";
import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import authHeader from "services/auth-header";
import API from "services/axios";
import useInbox from "../InboxContext";
import { useDispatch } from "react-redux";

export default function SwitchEmail() {
  /*   All States
   ********************************************* */
  const dispatch = useDispatch();

  const {
    emailGrants,
    setEmailGrants,
    selectedGrantEmail,
    setSelectedGrantEmail,
    refreshGrantEmails,
    setRefreshEmails,
    resetAll,
  } = useInbox();

  /*   All Functions
   ********************************************* */
  // api call to set selected as default email grant
  const setDefaultEmailGrant = async (emailGrant) => {
    try {
      const { data } = await API.post(
        "/email-grants/set-default",
        { id: emailGrant.id },
        { headers: authHeader() }
      );
      if (data?.success) {
        setEmailGrants((prev) => data.data);
        setSelectedGrantEmail(emailGrant.email);
        resetAll();
        setRefreshEmails(true);
      } else {
        dispatch(
          setNotification({
            message: "Failed to set default email",
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    let timeout = setTimeout(() => {
      refreshGrantEmails();
    }, 50);
    return () => clearTimeout(timeout);
  }, [refreshGrantEmails]);
  if (!emailGrants || emailGrants.length === 0) {
    return null;
  }
  return (
    <div>
      <Dropdown>
        <Dropdown.Toggle
          className="w-100 rounded-pill"
          variant="outline-secondary"
          id="dropdown-basic"
        >
          {selectedGrantEmail}
        </Dropdown.Toggle>
        <Dropdown.Menu className="w-100 custom-shadow-sm bg-white px-2 py-2">
          {emailGrants.map((emailGrant) => (
            <Dropdown.Item
              key={emailGrant.email}
              active={selectedGrantEmail === emailGrant.email}
              onClick={() => setDefaultEmailGrant(emailGrant)}
              className={`text-center px-0
                ${
                  selectedGrantEmail === emailGrant.email
                    ? "text-primary fw-bold"
                    : ""
                }`}
            >
              {emailGrant.email}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
